/**
 * Created by Jerker Nord on 2019-03-12.
 */
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSpine} from "@nolimitcity/slot-game/bin/core/displayobject/TimelineSpine";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";
import Container = PIXI.Container;

export class ThorFreeSpinBoxView extends BaseView {

    private static readonly FREE_SPIN_BOX_POSITION:PIXI.Point = new PIXI.Point(188, -2);
    private static readonly FREE_SPIN_METER_ANIMATION:PIXI.Point = new PIXI.Point(214, 50);
    private static readonly FREE_SPIN_METER_STEPS:string[] = ["M_FillTwo", "AnticipationThrd", "MoreSpins"];
    public static thorFreeSpinBoxView:ThorFreeSpinBoxView;

    private _freeSpinMeter:PIXI.spine.Spine;
    private _freeSpinBoxContainer:PIXI.Container;
    private _layer:ScalableLayer;
    private _currentBoxLevel:number = 0;
    private _resetFSBoxTL:TimelineLite;
    private _freeSpinsWonAnimation:TimelineSpine;
    private _FSCounter:PIXI.BitmapText;
    private _numberOfFSWon:number;
    private _isFSMeterActive:boolean = false;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.SCATTER_ANIMATION.name);
        this._layer.addChild(this);
        this._freeSpinBoxContainer = new PIXI.Container();
        this._freeSpinBoxContainer.position = ThorFreeSpinBoxView.FREE_SPIN_BOX_POSITION;
        this.addChild(this._freeSpinBoxContainer);
        this._numberOfFSWon = 10;
        ThorFreeSpinBoxView.thorFreeSpinBoxView = this;
    }

    protected initAnimations():void {
        this._freeSpinMeter = new PIXI.spine.Spine(GameResources.getSpineAsset("scatterMeterSpine"));
        this._freeSpinMeter.position = ThorFreeSpinBoxView.FREE_SPIN_METER_ANIMATION;
        this._freeSpinBoxContainer.addChild(this._freeSpinMeter);

        this._freeSpinsWonAnimation = new TimelineSpine(GameResources.getSpineAsset("FSWonSpine"));
        this._freeSpinsWonAnimation.position.set(ThorGameConfig.instance.GAME_WIDTH / 2, ThorGameConfig.instance.GAME_HEIGHT / 2 - 60);
        this._freeSpinsWonAnimation.hide();
        this.addChild(this._freeSpinsWonAnimation);

        const freeSpinCounterContainer:PIXI.Container = new Container();
        freeSpinCounterContainer.position = new PIXI.Point(443, 46);
        this.addChild(freeSpinCounterContainer);

        this._FSCounter = new PIXI.BitmapText(this._numberOfFSWon.toString(), {
            fontName: ThorGameConfig.TEXT_STYLES.FS_WIN_NUMBER.font.name!,
            fontSize: ThorGameConfig.TEXT_STYLES.FS_WIN_NUMBER.font.size
        });
        this._FSCounter.alpha = 0;
        this._FSCounter.anchor = new PIXI.Point(0.5, 0.5);
        freeSpinCounterContainer.addChild(this._FSCounter);

        this.createResetFSBoxTL();
    }

    public updateFSNumber(fs:number):void {
        this._FSCounter.alpha = 1;
        this._FSCounter.text = fs.toString();
    }

    private createResetFSBoxTL():void {
        this._resetFSBoxTL = new TimelineLite({paused : true});
        this._resetFSBoxTL.add(() => this._FSCounter.alpha = 0.05);
        this._resetFSBoxTL.add(new TweenLite(this._FSCounter, 0.2, {alpha : 0}));
        this._resetFSBoxTL.add(() => this._numberOfFSWon = 10);
    }

    public resetFreeSpinBoxFSEnd():void {
        this._currentBoxLevel = 0;
        this.resetFreeSpinEnds();
    }

    public showFreeSpinBox():void {
        this._currentBoxLevel = 0;
    }

    public resetFreeSpinEnds():void {
        this._freeSpinsWonAnimation.hide();
        this._resetFSBoxTL.restart();
    }

    public resetScatterMeter():void {
        if(this._isFSMeterActive == true) {
            this._isFSMeterActive = false;
            new SpineTween(this._freeSpinMeter, 0, "SpinsFade", 0);
        }
    }

    private getMoreAndLoopingMeterTL():TimelineLite {
        const TL:TimelineLite = new TimelineLite();
        TL.add(new SpineTween(this._freeSpinMeter, 0, "MoreSpins", 0));
        TL.add(new SpineTween(this._freeSpinMeter, 0, "AnticipationThrd", -1));
        return TL;
    }

    public getUpdateFreeSpinBoxMeterTL():TimelineLite {
        const freeSpinBoxMeterTL:TimelineLite = new TimelineLite();
        this._currentBoxLevel++;
        if(this._currentBoxLevel == 3) {
            this._freeSpinsWonAnimation.state.timeScale = 1;
            freeSpinBoxMeterTL.add(() => this._freeSpinsWonAnimation.show());
            freeSpinBoxMeterTL.add(() => this._FSCounter.text = this._numberOfFSWon.toString());
            this._currentBoxLevel++;
            freeSpinBoxMeterTL.add([
                this._freeSpinsWonAnimation.getAnimation("Freespins"),
                () => SlotGame.sound.playEffect(ThorSoundConfig.instance.ASGARD_WIN),
                new TweenLite(this._FSCounter, 0.4, {alpha : 1}),
                this.getMoreAndLoopingMeterTL(),
                () => this._isFSMeterActive = true,
                () => SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_METER_UP)
            ]);
            freeSpinBoxMeterTL.add(() => this._freeSpinsWonAnimation.hide());
        } else if(this._currentBoxLevel > 3) {
            freeSpinBoxMeterTL.add(() => this._numberOfFSWon += 2);
            freeSpinBoxMeterTL.add(() => this.updateFSNumber(this._numberOfFSWon));
            freeSpinBoxMeterTL.add([
                new SpineTween(this._freeSpinMeter, 0, "MoreSpins", 0),
                () => this._isFSMeterActive = true,
                () => SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_METER_UP)
            ]);
            freeSpinBoxMeterTL.add(new SpineTween(this._freeSpinMeter, 0, "AnticipationThrd", -1));
        } else if(this._currentBoxLevel == 1) {
            freeSpinBoxMeterTL.add([
                new SpineTween(this._freeSpinMeter, 0, "M_FillTwo", 0),
                () => this._isFSMeterActive = true,
                () => SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_METER_UP)
            ]);
            freeSpinBoxMeterTL.add(new SpineTween(this._freeSpinMeter, 0, "AnticipationThrd", -1));
        }

        return freeSpinBoxMeterTL;
    }

    public abortFreeSpinBoxMeter():void {
        const abortTL:TimelineLite = new TimelineLite();
        if(this._currentBoxLevel == 4) {
            this._freeSpinsWonAnimation.state.timeScale = 4;
            abortTL.add(() => this._freeSpinsWonAnimation.show());
            abortTL.add(() => this._FSCounter.text = this._numberOfFSWon.toString());
            abortTL.add([
                this._freeSpinsWonAnimation.getAnimation("Freespins"),
                () => SlotGame.sound.playEffect(ThorSoundConfig.instance.ASGARD_WIN),
                new TweenLite(this._FSCounter, 0.4, {alpha : 1}),
                this.getMoreAndLoopingMeterTL(),
                () => this._isFSMeterActive = true,
                () => SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_METER_UP)
            ]);
            abortTL.add(() => this._freeSpinsWonAnimation.hide());
        } else if(this._currentBoxLevel > 4) {
            abortTL.add([
                new SpineTween(this._freeSpinMeter, 0, "MoreSpins", 0),
                () => this._isFSMeterActive = true,
                () => SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_METER_UP)
            ]);
            abortTL.add(new SpineTween(this._freeSpinMeter, 0, "AnticipationThrd", -1));
        } else if(this._currentBoxLevel == 2) {
            abortTL.add([
                new SpineTween(this._freeSpinMeter, 0, "M_FillTwo", 0),
                () => this._isFSMeterActive = true,
                () => SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_METER_UP)
            ]);
            abortTL.add(new SpineTween(this._freeSpinMeter, 0, "AnticipationThrd", -1));
        }
    }

    set currentBoxLevel(value:number) {
        this._currentBoxLevel = value;
    }

    get currentBoxLevel():number {
        return this._currentBoxLevel;
    }
}